import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {CALL_STATUS} from "./constants";
import backendInfoAPI from "../../api/backend_info";

const initialState = {
	status: CALL_STATUS.IDLE,
	error: null
}

export const getBackendInfo = createAsyncThunk('backend_info/GET_BACKEND_INFO', async (token) => {
		const response = await backendInfoAPI.getBackendInfo(token);
		return response;
	}
);

const backendInfoSlice = createSlice({
	name: "backend_info",
	initialState,
	reducers: {
		reset: initialState
	},
	extraReducers: (builder) => {
		builder
			.addCase(getBackendInfo.pending, (state, action) => {
				state.status = CALL_STATUS.PENDING;
				state.error = null;
			})
			.addCase(getBackendInfo.fulfilled, (state, action) => {
				state.status = CALL_STATUS.SUCCESS;
				state.error = null;
			})
			.addCase(getBackendInfo.rejected, (state, action) => {
				state.status = CALL_STATUS.SUCCESS;
				state.error = null;
			})
	}
});

const {actions, reducer} = backendInfoSlice;

export const {
	reset
} = actions;

export default reducer;